export const PageHeader = ({ title, subtitle, action }) => (
  <div className="flex items-start justify-between mb-6 gap-4 flex-wrap">
    <div>
      <h1 className="font-heading font-bold text-2xl text-slate-900 tracking-tight">{title}</h1>
      {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const StatCard = ({ label, value, icon: Icon, accent = "indigo", hint }) => {
  const colors = {
    indigo: "bg-indigo-50 text-indigo-600",
    emerald: "bg-emerald-50 text-emerald-600",
    amber: "bg-amber-50 text-amber-600",
    rose: "bg-rose-50 text-rose-600",
    blue: "bg-blue-50 text-blue-600",
    pink: "bg-pink-50 text-pink-600",
    slate: "bg-slate-100 text-slate-600",
  };
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4 sm:p-5">
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium text-slate-500">{label}</p>
        {Icon && <div className={`h-8 w-8 rounded-lg flex items-center justify-center ${colors[accent]}`}><Icon className="h-4 w-4" /></div>}
      </div>
      <p className="font-heading font-bold text-xl sm:text-2xl text-slate-900 mt-2">{value}</p>
      {hint && <p className="text-xs text-slate-400 mt-1">{hint}</p>}
    </div>
  );
};

export const EmptyState = ({ icon: Icon, text }) => (
  <div className="text-center py-16 text-slate-400">
    {Icon && <Icon className="h-10 w-10 mx-auto mb-3" />}
    <p className="text-sm">{text}</p>
  </div>
);
